import type React from "react";
import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useLocation, useNavigate } from "react-router-dom";

import { Loader } from "@/base/components/Global";
import { useUser } from "@/base/components/UserProvider";
import config from "@/constants/config";
import { NavigationPath } from "@/constants/navigation";

const postAuthPath =
  config.routerConfig.routerMode === "giftCard"
    ? NavigationPath.GiftCardStatus
    : NavigationPath.Home;

const AuthStartPage: React.FC = () => {
  const { isAuthenticated, isLoading, error, signinRedirect } = useAuth();
  const [_, { hasTriedSilentSignin }] = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  const shouldShowAuthError = error && !isLoading;

  useEffect(() => {
    if (!isAuthenticated && !isLoading && hasTriedSilentSignin) {
      void signinRedirect({
        redirect_uri: `${globalThis.origin}${location.pathname}${location.search}`,
      });
    } else if (isAuthenticated) {
      void navigate(postAuthPath);
    }
  }, [isAuthenticated, isLoading, hasTriedSilentSignin]);

  if (
    shouldShowAuthError &&
    process.env.NODE_ENV === "development" &&
    error.message === "login_required"
  ) {
    console.warn("Failed silent login, redirecting to SSO manually");
  }

  return <Loader />;
};

export default AuthStartPage;
